<script setup lang="ts">
import { STORYBLOK_ROUTES } from '#shared/constants/storyblok';
import { BackendErrorCode } from '~/apiClient';
import { type PlatformSaleItemEntity, isAuction } from '~/types/sale.type';

const CANT_PERFORM_ERROR_CODES = [
    BackendErrorCode.CantPerformUnapprovedCompany,
    BackendErrorCode.CantPerformScrapSaleNotScrapyardCompany,
    BackendErrorCode.CantPerformUserCompanyEqSellerCompany,
    BackendErrorCode.CantPerformCompanyUnderReview,
    BackendErrorCode.CantPerformUserWithoutCompany,
    BackendErrorCode.CantPerformCompanyNotYetApprovedForScrap,
    BackendErrorCode.CantPerformCompanyNotApprovedForScrap,
] as const;
type CantPerformErrorCode = (typeof CANT_PERFORM_ERROR_CODES)[number];

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}

const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const localePath = useLocalePath();

// COMPUTED
const cantPerformReason = computed(() => (isAuction(sale) ? sale.userMeta?.cantBidReason : sale.userMeta?.cantBuyReason));
const messageKey = computed<TranslationKey>(() => {
    const isCantPerformErrorCode = (code: BackendErrorCode): code is CantPerformErrorCode => CANT_PERFORM_ERROR_CODES.includes(code as any);

    return cantPerformReason.value && isCantPerformErrorCode(cantPerformReason.value)
        ? `sdp.${sale.sellingMethod}.notice.cantPerform.${cantPerformReason.value}`
        : `sdp.${sale.sellingMethod}.notice.cantPerform.generic`;
});
const to = computed(() =>
    cantPerformReason.value === BackendErrorCode.CantPerformScrapSaleNotScrapyardCompany ? localePath(`${STORYBLOK_ROUTES.FAQ}#scrapping`) : undefined
);
</script>

<template>
    <SdpSalePanelNoticeBase :message="tt(messageKey)" :to="to" icon-class="text-primary" icon-name="lucide:info" />
</template>
